define('lib/util/feature-expanders',['jquery'], function ($) {
  return function enableFeatureExpanders() {
    $('.feature-header').on('click keydown', function (event) {
      var $this = $(this);
      var yPos = event.pageY - $this.offset().top;
      if (event.keyCode && event.keyCode !== 13 && event.keyCode !== 32) {
        return; // BAT-4385 keydown and keycode items for ADA
      }
      if (event.keyCode) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (yPos > 40) {
        return; // BAT-2980. only allow open / close on top portion of this header.
      }
      // No more DL related things in this spot, do elsewhere as needed
      $this.find('.icon-arrow-up').toggleClass('active');
      $this.find('.icon-arrow-down').toggleClass('active');
      $this.find('.feature-content').toggleClass('expanded');
    });
  };
});

